import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function CourseOnGoing() {
  const { searchObject, t, setSearchObject } = useAdvanceSearchContext();

  function oncheckBoxCheked({ target }) {
    setSearchObject({
      ...searchObject,
      [target.name]: target.checked
    });
  }
  
  return (
    <>
      <fieldset>
        <legend>{t("Course OnGoing")}</legend>
        <input
          type="checkbox"
          className="form-check-input"
          name="onGoing"
          checked={searchObject.onGoing}
          onChange={oncheckBoxCheked}
        />
        <label className="form-check-label" style={{marginLeft:"10px"}}>{t("Course OnGoing")}</label>
      </fieldset>
    </>
  );
}
